<template>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="top-banner-box">
                <!-- <MapLegend
                    :items="[
                        { name: 'Closest sample site', colour: 'hsl(141,96%,37%)', type: 'site' },
                        {
                            name: `Other ${sampleGroup.heading} sites`,
                            colour: getClassicalColour('roman'),
                            type: 'site',
                        },
                        {
                            name: `${sampleGroup.heading} geographical area`,
                            colour: getClassicalColour('roman'),
                            type: 'main-area',
                        },
                        {
                            name: `Roman Empire`,
                            colour: getClassicalColour('roman'),
                            type: 'area',
                        },
                        {
                            name: `Other roman sites`,
                            colour: '#ccc',
                            type: 'site',
                        },
                    ]"
                /> -->
                <div class="map-legend map-classical-row-legend-flex">
                    <div class="d-flex flex-wrap p-4">
                        <div class="p-3" v-for="(legend, index) in mapLegends" :key="index">
                            <span class="legend-circle" :style="{ backgroundColor: legend.colour }"></span>
                            {{ legend.name }}
                        </div>
                    </div>
                </div>
                <BaseMap v-if="showMap && mode === 'map'" type="satellite" class="h-full" @map-loaded="onMapLoaded" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-7 col-xl-12 roman-map-classical-container">
            <div class="inner-box py-1">
                <div class="inner-content">
                    <div class="banner-box">
                        <img class="rounded-4 h-400 img-row-feedback" :src="sampleGroup.main_image.url" />
                    </div>
                    <h4 class="mt-4"><b>{{ sampleGroup.heading }}</b></h4>

                    <div v-if="closestSampleInfo" class="result-map-bar my-3 p-4 rounded-4">
                        <div class="row w-100">
                            <div class="col-2">
                                <p>Closest Sample</p>
                                <h4 class="d-flex text-start"><b>{{ closestSampleInfo.properties.id }}</b></h4>
                            </div>
                            <div class="col-6">
                                <p>Location</p>
                                <h4 class="d-flex text-start">
                                    <b>{{ closestSampleInfo.properties.location }}</b>
                                </h4>
                            </div>
                            <div class="col-2">
                                <p>Time Zone</p>
                                <h4 class="d-flex text-start"><b>{{ closestSampleInfo.properties.date }}</b></h4>
                            </div>
                            <div class="col-2 d-flex align-items-center">
                                <button v-if="!hasZoomed" @click="zoom" class="load-btn m-auto">
                                    <FeatherWrapper icon="zoom-in" />
                                    <span>Zoom on Map</span>
                                </button>
                                <button v-else @click="resetZoom" class="load-btn m-auto">
                                    <FeatherWrapper icon="zoom-out" />
                                    <span>Reset</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="sampleGroup" v-html="sampleGroup.text" />
                    <!-- <h6 class="mb-3"><b>Time Range of Samples: 31 BCE - 200 CE</b></h6>
                    <p>
                        The Romans of Great Britain during this period represent the expansion of
                        the Roman Empire into Great Britain. Roman rule followed the conquest of
                        modern day England & Wales by Emperor Claudius in 43 CE. The Romans retained
                        their imperial authority until they withdrew in 410 CE.
                    </p>
                    <p>
                        Rome is thought to have first become aware of the peoples of Britain
                        following their conquest of Gaul in 55 BCE. The newly conquered tribes
                        living in modern day Northern France and Belgium shared their knowledge of
                        the nearby island. During that time, Caesar undertook two military
                        expeditions to Britain intended to gain knowledge about the southern region
                        of Britain and gather tribute from the local tribes. It wasn't until 43 CE
                        That Emperor Claudius ordered four Roman legions to conquer Britain. Five
                        years later, most of the area of modern day England was conquered but
                        Dumnonii (Cornwall and Devon), Wales and the North West of England continued
                        to resist. Yet it took another 40 years before all of what would become
                        England and Wales had fallen under Roman rule - a result of numerous
                        rebellions within the newly conquered territory as well as persistent
                        resistance at the frontier. At the end of the century Emperor Trajan ordered
                        a complete withdrawal from Scotland and the construction of a new frontier
                        between the east and west coasts, but It was 22 years later (122 BCE) that
                        Emperor Hadrian ordered the construction of the wall bearing his name.
                    </p>
                    <p>
                        In more than 300 years of rule the Romans built many cities, roads and
                        monuments that still exist to this day. Examples include the Roman baths in
                        the city of Bath, and Hadrian's Wall in the north of England that marked the
                        boundary between Roman Britannia and unconquered Caledonia to the north.
                    </p> -->
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.sampleGroup > p:first-of-type {
    font-weight: bold !important;
    margin-bottom: 1rem;
    font-size: 0.98rem;
}
</style>
<script setup>
import { inject, ref, defineProps } from "vue";
import BaseMap from "@/components/Maps/BaseMap.vue";
// import Sidebar from "@/components/Sidebar.vue";
import {
    attachClassicalShapesToMap,
    attachClassicalSitesToMap,
    zoomToGroup,
} from "@/view/ancestry/recent/mapHelpers";
// import MobileContent from "@/components/ancestry/MobileContent.vue";
// import ClosestSample from "@/components/Classical/ClosestSample.vue";
// import MapLegend from "@/components/MapLegend.vue";
import { getClassicalColour } from "@/composables/useClassicalContent";

const props = defineProps({
    introduction: Object,
    sampleGroup: Object,
    sampleSites: Object,
});

const showMap = ref(false);
const mode = ref("map");
const mapRef = ref({});
const hasZoomed = ref(false);
const result = inject("roman-result");
const closestSampleInfo = ref(null);

const mapLegends = [
    { name: "Closest sample site", colour: "hsl(141,96%,37%)", type: "site" },
    {
        name: `Other ${props?.sampleGroup.heading} sites`,
        colour: getClassicalColour("roman"),
        type: "site",
    },
    {
        name: `${props?.sampleGroup.heading} geographical area`,
        colour: getClassicalColour("roman"),
        type: "main-area",
    },
    {
        name: `Roman Empire`,
        colour: getClassicalColour("roman"),
        type: "area",
    },
    {
        name: `Other roman sites`,
        colour: "#ccc",
        type: "site",
    },
];

setTimeout(() => {
    showMap.value = true;
});
function zoom() {
    window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
    });
    hasZoomed.value = true;
    const [sampleGroupFeature] = JSON.parse(props?.sampleGroup?.plain_text).features;
    zoomToGroup(mapRef.value, sampleGroupFeature);
}

function resetZoom() {
    hasZoomed.value = false;
    const [feature] = JSON.parse(props?.introduction?.plain_text).features;
    zoomToGroup(mapRef.value, feature);
}

function onMapLoaded(map) {
    mapRef.value = map;

    const sites = JSON.parse(props?.sampleSites?.plain_text).features;
    const [feature] = JSON.parse(props?.introduction?.plain_text).features;
    const [sampleGroupFeature] = JSON.parse(props?.sampleGroup?.plain_text).features;

    attachClassicalShapesToMap(map, {
        people: "roman",
        feature,
        type: "main",
    });

    attachClassicalShapesToMap(map, {
        people: "roman",
        feature: sampleGroupFeature,
        type: "sampleGroup",
    });

    zoomToGroup(map, feature);

    const siteInfo = attachClassicalSitesToMap(map, {
        sites,
        people: "roman",
        closestSample: result?.romans?.closest_sample,
    });
    console.log(result, result?.romans?.closest_sample, "result?.romans?.closest_sample");

    closestSampleInfo.value = siteInfo.pop();
}
</script>
